import React from 'react';
import styled from 'styled-components';

type ImageProps = {
	src: string;
	height: number;
	width?: number;
	position?: string;
	size?: string;
	redLine?: boolean;
};

const StyledImage = styled.div<ImageProps>`
	background-color: #c1c1c1;
	background-image: url(${({ src }) => src});
	background-repeat: no-repeat;
	background-size: ${({ size }) => size || 'cover'};
	height: ${({ height }) => height}px;
	width: ${({ width }) => (!width ? '100%' : width + 'px')};
	background-position: ${({ position }) => position || 'center'};
	position: relative;

	${({ redLine }) =>
		redLine &&
		`
    &:before {
			content: '';
			position: absolute;
			left: -14px;
			top: 5%;
			background-color: #E3232A;
			width: 15px;
			height: 40%;
		}
  `}
`;

const Image = ({ src, width, height, position, size, redLine }: ImageProps) => {
	return (
		<>
			<StyledImage
				src={src}
				height={height}
				width={width}
				position={position}
				size={size}
				redLine={redLine}
			/>
		</>
	);
};

export default Image;
